module.exports = __webpack_public_path__ + "static/img/activity_five.5e3fa102.jpg";